import React from "react";
import { Toast } from "react-bootstrap";
import logo from "../assets/images/logo_black.png";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { hideToast } from "../redux/slices/Toasts";
import { RootState } from "../redux/store";

export const ToastMessages = () => {
    const dispatch = useAppDispatch();
    const toasts = useAppSelector((state: RootState) => state.toasts);

    return (
        <div style={{ position: "fixed", top: 50, right: 20, zIndex: 2000000 }}>
            {toasts.toasts.map((props) =>
                <div key={props.key}>
                    <div className="toast-container" style={{ position: "relative" }}>
                        <Toast onClose={() => dispatch(hideToast({ value: props.key }))} show={props.open} delay={props.duration} autohide>
                            <Toast.Header>
                                <strong className="me-auto">
                                    <img src={logo} alt="brand-logo" height="10" className="me-1" />
                                </strong>
                            </Toast.Header>
                            <Toast.Body>
                                {props.messages.map((item, index) => 
                                    <React.Fragment key={index}>
                                        {item}
                                        {index === props.messages.length - 1 ? (<></>) : (<br />)}
                                    </React.Fragment>
                                )}
                            </Toast.Body>
                        </Toast>
                    </div>
                </div>
            )}
        </div>
    );
};